import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  Switch,
  Container
} from '@material-ui/core';
import AddCommentOutlinedIcon from '@material-ui/icons/AddCommentOutlined';
import CloseIcon from '@material-ui/icons/Close';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import HistoryIcon from '@material-ui/icons/History';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import ListIcon from '@material-ui/icons/List';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Degisim from 'src/views/WorkOrder/ProductChange';
import Compensation from 'src/views/WorkOrder/CompensationForm';
import DisplayField from '../../components/DisplayField';
import UrunTarihce from '../../components/ProductHistory';
import AppReasonSearch from '../../components/Selects/AppReasonSearch';
import RetailerSearch from '../../components/Selects/RetailerSearch';
import { setTask } from '../../store/actions/taskActions';
import Bulten from './Bulletin';
import BomListLibrary from '../../components/BomListLibrary';
import Hizmet from './Defect';
import Tarihce from './History';
import Fotograf from './Photo';
import Urun from './Product';
import Warranty from './Warranty';
import SaveIcon from '@material-ui/icons/Save';
import Moment from 'moment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ProductBom from 'src/components/ProductBom';
import DistributorSearch from 'src/components/Selects/DistributorSearch';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Comment from 'src/components/Comment';
import ChatIcon from '@material-ui/icons/Chat';
import moment from 'moment';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import EditIcon from '@material-ui/icons/Edit';
import { DateTimePicker } from '@material-ui/pickers';
import LoanProduct from './LoanProduct';
import { getSiriusUserTypeList } from 'src/store/slices/userTypesSlice';

// System bazlı konfigürasyon
// repairDateEditUserTypeIds: Repair date edit yetkisi olan user type'lar (EG: GFSM-7863)
// TODO: yeni ülkenin user type Id'leri eklenecek
const SYSTEM_CONFIG = {
  Local: {
    repairDateEditUserTypeIds: [1238, 1244],
  },
  Test: {
    repairDateEditUserTypeIds: [1238, 1244],
  },
  Live: {
    repairDateEditUserTypeIds: [1218, 1233],
  },
};

const currentSystem = process.env.REACT_APP_SYSTEM || 'Live';
const currentConfig = SYSTEM_CONFIG[currentSystem] || SYSTEM_CONFIG.Live;

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    minHeight: 430
  },
  submitButtonFile: {
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  cardsMax: {
    maxHeight: 550,
    minHeight: 550
  }
}));
function Summary({ className, ReceiptNo, readonly, tasks, setTask }) {
  const { t } = useTranslation('work_order');

  const [data, setData] = useState({});
  const [FileDialog, setFileDialog] = useState(false);
  const [WorkOrderHistoryDialog, setWorkOrderHistoryDialog] = useState(false);
  const [ProductHistoryDialog, setProductHistoryDialog] = useState(false);
  const [LibraryDialog, setLibraryDialog] = useState(false);
  const [CommentTypeData, setCommentTypeData] = useState([]);
  const [CommentTypeId, setCommentTypeId] = useState('');
  const [CommentType, setCommentType] = useState('');
  const [BomList, setBomList] = useState(false);
  const [TaskType, setTaskType] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [loading2, setLoading2] = useState(false);
  const [CommentDialog, setCommentDialog] = useState(false);
  const [WorkOrderCommentsData, setWorkOrderCommentsData] = useState([]);
  const [ProductChangePopup, setProductChangePopup] = React.useState(false);
  const [CompensationPopup, setCompensationPopup] = React.useState(false);
  const [ProductBOMPopup, setProductBOMPopup] = useState(false);
  const [PriorityData, setPriorityData] = useState([]);
  const [ChannelId, setChannelId] = React.useState(0);
  const [TaskTypeId, setTaskTypeId] = React.useState(0);
  const [ChannelData, setChannelData] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
  const [userPotentialLiability, setUserPotentialLiability] = useState('');
  const [LoanProductDialog, setLoanProductDialog] = useState(false);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [repairDateDialog, setRepairDateDialog] = useState(false);
  const [repairDateValue, setRepairDateValue] = useState('');
  const [IsLoanProductCountry, setIsLoanProductCountry] = useState(false);


  const classes = useStyles();
  const search = '';
  const SessionUser = getUser();
  

  Moment.locale(
    SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode
  );

  useEffect(() => {
    if (tasks?.tasks.length === 0) {
      setData({});
    } else {
      const storeData = tasks.tasks.filter(
        d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
      );
      if (storeData.length !== 0) {
        setData(storeData[0]);
        if (storeData[0].ChannelId == 0 || storeData[0].ChannelId == 1) {
          setChannelId(28);
        } else {
          setChannelId(storeData[0].ChannelId);
        }
        if (storeData[0].TaskTypeId != undefined || storeData[0].TaskTypeId != null) {
          setTaskTypeId(storeData[0].TaskTypeId)
        }
        setCommentType(
          storeData[0]?.WorkOrderComments[
            storeData[0]?.WorkOrderComments?.length - 1
          ]?.Dsc
        );
      } else {
        setData({});
      }
    }
  }, [ReceiptNo, tasks.tasks, readonly]);

  const setIssue = param => {
    let job = data;
    job = {
      ...job,
      IssueReason: param.Dsc,
      IssueId: param.Id
    };
    setData(job);
    setTask(job);
  };
  const setRetailer = param => {
    let job = data;
    job = {
      ...job,
      RetailerDescription: param.Dsc,
      RetailerId: param.Id
    };
    setData(job);
    setTask(job);
  };

  const setDistributor = param => {
    let job = data;
    job = {
      ...job,
      Distributor: param.Dsc,
      DistributorId: param.Id
    };
    setData(job);
    setTask(job);
  };

  useEffect(() => {
    GetWorkOrderCommentType();
    GetPriority();
    GetWorkOrderChannel();
    getWorkOrderCommentDetail();
    GetTaskType();
    GetSiriusUserTypeList();
    getLoanProductCountry();
  }, [ReceiptNo]);

  const getLoanProductCountry = () => {
    axios
      .get(
        `/GetLoanProductCountry/${parseInt(SessionUser.TenantId)}`
      )
      .then(response => {
        if (response.data == false) {
          setIsLoanProductCountry(false);
        } else {
          setIsLoanProductCountry(true);
        }
      })
      .catch(error => {});
  };

  const setPriority = event => {
    let job = data;
    job = {
      ...job,
      PriorityId: event.target.value
    };
    setData(job);
    setTask(job);
  };
  const setDataContactName = event => {
    let job = data;
    job = {
      ...job,
      ContactName: event.target.value
    };
    setData(job);
    setTask(job);
  };
  const GetPriority = () => {
    axios
      .get(`/GetPriority`)
      .then(response => {
        if (response.data.length > 0) {
          setPriorityData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetWorkOrderCommentType = () => {
    axios
      .get(`/GetWorkOrderCommentType`)
      .then(response => {
        if (response.data.length > 0) {
          setCommentTypeData(response.data);
          const storeData1 = tasks.tasks.filter(
            d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
          );
          const TypeControl = response.data.filter(
            x =>
              x.Dsc ===
              storeData1[0]?.WorkOrderComments[
                storeData1[0]?.WorkOrderComments?.length - 1
              ]?.Type
          );
          setCommentTypeId(TypeControl[0]?.Id);
        }
      })
      .catch(error => { });
  };

  const getWorkOrderCommentDetail = () => {
    axios
      .get(`/GetWorkOrderCommentDetail/${ReceiptNo}`)
      .then(response => {
        if (response.data.length > 0) {
          setWorkOrderCommentsData(response.data);
          // setCommentDialog(true);

        }
      })
      .catch(error => { });
  };

  const getWorkOrderComment = () => {
    setCommentDialog(true);

  };

  function ScrollableDialogContent(props) {
    return (
      <div style={{ overflow: 'paper', height: 'calc(30vh - 160px)' }}>
        {props.children}
      </div>
    )
  }

  const setDataContactPhone = Phone => {
    let job = data;
    job = {
      ...job,
      ContactPhone: Phone
    };
    setData(job);
    setTask(job);
  };


  const handleSendWorkOrderComment = () => {
    if (CommentTypeId === 0 || CommentTypeId === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    if (CommentType.length === 0 || CommentType.replace(' ', '') === '') {
      setresponseMessage({
        ErrorCode: '10',
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    const data = {
      WorkOrderId: ReceiptNo,
      CommentTypeId: CommentTypeId || 0,
      CommentType: CommentType || '',
      EmployeeId: SessionUser.TechnicianId
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading2(true);
    axios
      .post('/SetWorkOrderComment', data, config)
      .then(response => {
        setLoading2(false);
        const ResponseData = response.data;
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
          getWorkOrderCommentDetail();
        } else {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          setCommentTypeId(data.CommentTypeId);
          setCommentType(data.CommentType);
          getWorkOrderCommentDetail();
          setCommentDialog(false);
        }
      })
      .catch(error => {
        setLoading2(false);
        setresponseMessage({
          ErrorCode: '10',
          ErrorDescription: t('Error') + error.message
        });
        setUyariTip('error');
        setUyari(true);
      });
  };
  const GetWorkOrderChannel = () => {
    if (ChannelData.length < 1) {
      axios
        .get(`/GetWorkOrderChannel`)
        .then(response => {
          if (response.data.length > 0) {
            setChannelData(response.data);
          }
        })
        .catch(error => { });
    }
  };
  const GetTaskType = () => {
    if (ChannelData.length < 1) {
      axios
        .get(`/GetActiveTaskType`)
        .then(response => {
          if (response.data.length > 0) {
            setTaskType(response.data);
          }
        })
        .catch(error => { });
    }
  };

  const setChannelType = event => {
    let job = data;
    job = {
      ...job,
      ChannelId: event.target.value
    };
    setChannelId(event.target.value);
    setData(job);
    setTask(job);
  };
  const setActiveTaskType = event => {
    let job = data;
    job = {
      ...job,
      TaskTypeId: event.target.value
    };
    setTaskTypeId(event.target.value);
    setData(job);
    setTask(job);

  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleOnCheck = event => {
    event.persist();
    var UrgentCustomer = 0;
    if (event.target.checked) {
      UrgentCustomer = 1;
    } else {
      UrgentCustomer = 0;
    }

    let job = data;
    job = {
      ...job,
      UrgentCustomer: UrgentCustomer
    };
    setData(job);
    setTask(job);
  };

  const SaveCompensation = () => {
    const dataBody = {
      WorkOrderId: ReceiptNo,
    };

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetCompensationForPotentialLiability', dataBody, dataConfig)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        if (res[0].ErrorCode === 0) {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: res[0].ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
      });
  }

  const handlePotentialLiabiltiy = event => {
    event.persist();
    var PotentialLiabiltiy = 0;
    if (event.target.checked) {
      PotentialLiabiltiy = 1;
    } else {
      PotentialLiabiltiy = 0;
    }

    let job = data;
    job = {
      ...job,
      PotentialLiabiltiy: PotentialLiabiltiy
    };
    setData(job);
    setTask(job);

    if (PotentialLiabiltiy == 1) {
      SaveCompensation();
    }
  };

  const SetRepairDate = () => {
    if (data.WorkCaseCallDate && moment(repairDateValue).isBefore(moment(data.WorkCaseCallDate))) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblRepairDateCannotBeBeforeCallDate')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    const dataBody = {
      Ids: [parseInt(ReceiptNo)],
      EditDate: moment(repairDateValue).format('YYYY-MM-DDTHH:mm:ss'),
      EmployeeId: SessionUser.TechnicianId
    };
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetRepairDate', dataBody, dataConfig)
      .then(response => {
        if (response.data === true) {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
          setRepairDateDialog(false);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('lblMustFieldControl')
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const getBomList = () => {
    setLibraryDialog(false);
    setBomList(true);
  };

  const GetSiriusUserTypeList = () => {
    axios
      .get(
        `/GetSiriusUserTypeList/${SessionUser.TechnicianId}`
      )
      .then(response => {
        if (response.data.length > 0 && response.data != "") {
          setUserTypes(response.data);
          if (response.data.find(x => x.IsPotentialLiability === true)) {
            setUserPotentialLiability(true);
          } else {
            setUserPotentialLiability(false);
          }
        } else {
          setUserTypes([]); //no data
        }
      })
      .catch(error => {
      });
  };
  const isTenant118 = SessionUser.IsIhpTenant || SessionUser.TenantId === 64;
  return (
    <Card>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading2}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={isTenant118 ? 12 : 4} lg={4}>
            <Card className={classes.cardsMax}>
              <CardHeader title={t('lblWorkOrderDetail')} />
              <Divider />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      size="small"
                      fullWidth
                      select
                      label={t('lblPriority')}
                      value={data?.PriorityId ? data.PriorityId : 1}
                      onChange={event => setPriority(event)}
                      variant="outlined"
                    >
                      {PriorityData.map(p => {
                        return (
                          <MenuItem key={p.Id} value={p.Id}>
                            {p.Dsc}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      size="small"
                      fullWidth
                      select
                      label={t('lblChannel')}
                      value={ChannelId}
                      onChange={event => setChannelType(event)}
                      variant="outlined"
                    >
                      {ChannelData.map(p => {
                        return (
                          <MenuItem key={p.Id} value={p.Id}>
                            {p.Dsc}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      size="small"
                      fullWidth
                      select
                      label={t('Task Type')}
                      value={TaskTypeId}
                      onChange={event => setActiveTaskType(event)}
                      variant="outlined"
                    >
                      {TaskType.map(p => {
                        return (
                          <MenuItem key={p.Id} value={p.Id}>
                            {p.Dsc}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <AppReasonSearch
                      setIssue={setIssue}
                      value={
                        {
                          Dsc: data.IssueReason || '',
                          Id: data.IssueId || 0
                        } || ''
                      }
                      searchParam={search}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <RetailerSearch
                      setRetailer={setRetailer}
                      value={
                        {
                          Dsc: data.RetailerDescription || '',
                          Id: data.RetailerId || 0
                        } || ''
                      }
                      searchParam={search}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={4}>
                    <TextField
                      size="small"
                      id="ContactName"
                      label={t('lblContact')}
                      value={data?.ContactName ? data.ContactName : ''}
                      onChange={event => setDataContactName(event)}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={4}>
                    <DistributorSearch
                      setDistributor={setDistributor}
                      value={
                        {
                          Dsc: data.Distributor || '',
                          Id: data.DistributorId || 0
                        } || ''
                      }
                      searchParam={search}
                    />
                  </Grid>
                   {!SessionUser?.IsIhpTenant && (
                      <>
                        <Grid item xs={12} sm={3} lg={3}>
                          <FormControlLabel
                            control={
                              <Switch
                                color="primary"
                                disabled={userPotentialLiability === false ? true : false}
                                checked={data.PotentialLiabiltiy === 1 || false}
                                onChange={handlePotentialLiabiltiy}
                                name="PotentialLiabiltiy"
                              />
                            }
                            label={t('lblPotential')}
                          />
                        </Grid>

                        <Grid item xs={12} sm={1} lg={1}>
                          <Button onClick={() => setCompensationPopup(true)}>
                            <ListAltIcon style={{ color: data.Compensation > 0 ? 'green' : '' }} />
                          </Button>
                        </Grid>
                      </>
                    )}
                  <Grid item xs={9} sm={9} lg={9}>
                    <PhoneInput
                      country={SessionUser.TenantCode}
                      value={data.ContactPhone}
                      enableSearch
                      onChange={setDataContactPhone}
                      countryCodeEditable={false}
                      label={t('ContactPhone')}
                      containerStyle={{ textAlign: 'left' }}
                    // onChange={phone => this.setState({ phone })}
                    />
                  </Grid>
                  <Grid item xs={3} sm={3} lg={3}>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={data.UrgentCustomer === 1 || false}
                          onChange={handleOnCheck}
                          name="UrgentCustomer"
                        />
                      }
                      label={t('lblUrgentCustomer')}
                    />
                  </Grid>
                  {data.Phones?.length > 0 ? (
                    <Grid item xs={9} sm={9} lg={9}>
                      <PhoneInput
                        disabled
                        country={SessionUser.TenantCode}
                        value={data.Phones[1]?.Phone || data.Phones[0]?.Phone}
                        enableSearch
                        countryCodeEditable={false}
                        label={t('ContactPhone')}
                        containerStyle={{ textAlign: 'left' }}
                      // onChange={phone => this.setState({ phone })}
                      />
                    </Grid>)
                    :
                    (<></>)
                  }

                  <Grid
                    item
                    xs={6}
                    sm={6}
                    lg={6}
                    style={{ textAlign: 'left' }}
                  >
                    <IconButton onClick={getWorkOrderComment}>
                      <AddCommentOutlinedIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs={6} sm={6} lg={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={() => setOpenCommentDialog(true)}>
                      <ChatIcon />
                    </IconButton>
                  </Grid>
                  <DialogContent >
                    <ScrollableDialogContent>
                      {WorkOrderCommentsData
                        .sort((a, b) => (a.CreateDate > b.CreateDate ? -1 : 1))
                        .map((item, index) => (
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} lg={12} key={index} >
                              <Divider />
                              <DisplayField
                                label={`${item.Type}-${item.Employee}`}
                                value={item.Dsc}
                              />
                              {item.CreateDate != null ? <Typography className={classes.title} color="textSecondary">
                                {Moment(item.CreateDate).format('DD/MM/YYYY HH:mm')}
                              </Typography> : null}
                            </Grid>
                          </Grid>
                        ))}
                    </ScrollableDialogContent>
                  </DialogContent>

                  <Grid item xs={3}>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={isTenant118 ? 12 : 4} lg={4}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <Urun ReceiptNo={ReceiptNo} readonly={false} />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Warranty ReceiptNo={ReceiptNo} readonly={false} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={isTenant118 ? 12 : 4} lg={4}>
            <Card>
              <Hizmet ReceiptNo={ReceiptNo} readonly={false} />
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <Card>
              <CardContent style={{ paddingBottom: 16 }}>
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  style={{
                    overflowX: 'auto',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between'
                  }}
                >
                  <Grid item style={{ flex: '1 0 85px', minWidth: 85, paddingRight: 8 }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {t('lblCreateUser', 'Create User')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {data.CreateUser}
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '1 0 120px', minWidth: 120, paddingRight: 8 }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {t('lblCallDate', 'Call Date')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom style={{ whiteSpace: 'nowrap' }}>
                      {data.WorkCaseCallDate ? Moment(data.WorkCaseCallDate).format('DD/MM/YYYY HH:mm') : ''}
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '1 0 120px', minWidth: 120, paddingRight: 8 }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {t('lblPreferredDate', 'Preferred Date')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom style={{ whiteSpace: 'nowrap' }}>
                      {data.PreferredDate === undefined
                        ? ''
                        : Moment(data.PreferredDate).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '1 0 125px', minWidth: 125, paddingRight: 8 }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {t('lblFirstAppointmentDate', '1st Appointment')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom style={{ whiteSpace: 'nowrap' }}>
                      {data.FirstAppointmentDate === undefined
                        ? ''
                        : Moment(data.FirstAppointmentDate).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '1 0 120px', minWidth: 120, paddingRight: 8 }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {t('lblOperationStartDate', 'Start Date')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom style={{ whiteSpace: 'nowrap' }}>
                      {data.OperationStartDate === undefined
                        ? ''
                        : Moment(data.OperationStartDate).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '1 0 120px', minWidth: 120, paddingRight: 8 }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {t('lblBarcodeReadDate', 'Barcode Date')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom style={{ whiteSpace: 'nowrap' }}>
                      {data.BarcodeReadDate === undefined
                        ? ''
                        : Moment(data.BarcodeReadDate).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '1 0 135px', minWidth: 135, paddingRight: 8 }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {t('lblRepairDate', 'Repair Date')}
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="h6" component="h2" gutterBottom style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>
                        {data.VerificationDate === undefined
                          ? ''
                          : Moment(data.VerificationDate).format('DD/MM/YYYY HH:mm')}
                      </Typography>
                      {data.VerificationDate && userTypes.some(x => currentConfig.repairDateEditUserTypeIds.includes(x.UserTypeId)) && (
                        <IconButton
                          size="small"
                          style={{ marginLeft: 4 }}
                          onClick={() => {
                            setRepairDateValue(moment(data.VerificationDate).format('YYYY-MM-DDTHH:mm'));
                            setRepairDateDialog(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                  </Grid>

                  <Grid item style={{ flex: '0 0 auto', minWidth: 60, textAlign: 'center' }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                      {t('lblFile', 'File')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom>
                      <IconButton onClick={() => setFileDialog(true)}>
                        <PhotoLibraryIcon />
                      </IconButton>
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '0 0 auto', minWidth: 95, textAlign: 'center' }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                      {t('lblWorkOrderHistory', 'Work Order History')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom>
                      <IconButton onClick={() => setWorkOrderHistoryDialog(true)}>
                        <HistoryIcon />
                      </IconButton>
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '0 0 auto', minWidth: 80, textAlign: 'center' }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                      {t('lblProductHistory', 'Product History')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom>
                      <IconButton onClick={() => setProductHistoryDialog(true)}>
                        <SettingsBackupRestoreIcon />
                      </IconButton>
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '0 0 auto', minWidth: 65, textAlign: 'center' }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                      {t('lblLibrary', 'Library')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom>
                      <IconButton onClick={() => setLibraryDialog(true)}>
                        <LocalLibraryIcon />
                      </IconButton>
                    </Typography>
                  </Grid>

                  <Grid item style={{ flex: '0 0 auto', minWidth: 95, textAlign: 'center' }}>
                    <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                      {t('lblProductChange', 'Product ExChange')}
                    </Typography>
                    <Typography variant="h6" component="h2" gutterBottom>
                      <IconButton
                        onClick={() => setProductChangePopup(true)}
                        style={{ color: data.ChangeReason > 0 ? 'green' : '' }}
                      >
                        <TrackChangesIcon />
                      </IconButton>
                    </Typography>
                  </Grid>

                  {IsLoanProductCountry && (
                    <Grid item style={{ flex: '0 0 auto', minWidth: 80, textAlign: 'center' }}>
                      <Typography className={classes.title} color="textSecondary" style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                        {t('lblLoanProduct', 'Loan Product')}
                      </Typography>
                      <Typography variant="h6" component="h2" gutterBottom>
                        <IconButton onClick={() => setLoanProductDialog(true)}>
                          <FindReplaceIcon />
                        </IconButton>
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </CardContent>
      <Dialog
        open={FileDialog}
        // fullWidth={true}
        maxWidth="lg"
        onClose={event => setFileDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblFile')}</DialogTitle>
        <DialogContent>
          <Fotograf ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setFileDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={WorkOrderHistoryDialog}
        fullWidth
        maxWidth="lg"
        onClose={event => setWorkOrderHistoryDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('Fis_Tarihce')}</DialogTitle>
        <DialogContent>
          <Tarihce ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setWorkOrderHistoryDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ProductHistoryDialog}
        fullWidth
        maxWidth="lg"
        onClose={event => setProductHistoryDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('urun_tarihce')}</DialogTitle>
        <DialogContent>
          <UrunTarihce
            UrunData={data}
            setProductHistoryDialog={setProductHistoryDialog}
          />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setProductHistoryDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={LibraryDialog}
        fullWidth
        maxWidth="lg"
        onClose={event => setLibraryDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Button
            variant="contained"
            color="primary"
            style={{ alignItems: 'right' }}
            onClick={() => getBomList()}
            className={classes.button}
            endIcon={<ListIcon>send</ListIcon>}
          >
            BOM
          </Button>
        </DialogTitle>
        <DialogContent style={{ overflow: 'hidden' }}>
          <Bulten ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setLibraryDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={CommentDialog}
        fullWidth
        maxWidth="md"
        onClose={event => setCommentDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblComment')}</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={6} lg={12}>
              <TextField
                size="small"
                fullWidth
                select
                label={t('lblCommentType')}
                value={CommentTypeId}
                onChange={event => setCommentTypeId(event.target.value)}
                variant="outlined"
              >
                {CommentTypeData.map(p => {
                  return (
                    <MenuItem key={p.Id} value={p.Id}>
                      {p.Dsc}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} lg={12}>
              <TextField
                size="small"
                name="Note"
                multiline
                rows={6}
                fullWidth
                label={t('lblComment')}
                value={CommentType}
                onChange={event => setCommentType(event.target.value)}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton onClick={handleSendWorkOrderComment} >
            <SaveIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={event => setCommentDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ProductChangePopup}
        onClose={() => setProductChangePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <Degisim ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setProductChangePopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={CompensationPopup}
        onClose={() => setCompensationPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setCompensationPopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <Compensation ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={ProductBOMPopup}
        onClose={() => setProductBOMPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <ProductBom tasks={tasks} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setProductBOMPopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={BomList}
        fullWidth
        maxWidth="lg"
        onClose={event => setBomList(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{ overflow: 'hidden' }}>
          <BomListLibrary ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setBomList(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={LoanProductDialog}
        fullWidth
        maxWidth="sm"
        onClose={event => setLoanProductDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblLoanProduct')}</DialogTitle>
        <DialogContent>
          <LoanProduct ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setLoanProductDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={repairDateDialog}
        fullWidth
        maxWidth="xs"
        onClose={() => setRepairDateDialog(false)}
      >
        <DialogTitle>{`${t('lblWorkOrderId')}:${ReceiptNo}`}</DialogTitle>
        <DialogContent>
          <DateTimePicker
            label={t('lblRepairDate')}
            fullWidth
            value={repairDateValue}
            onChange={val => setRepairDateValue(val)}
            format="DD/MM/YYYY HH:mm"
            ampm={false}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={SetRepairDate}
          >
            {t('btnSave')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCommentDialog}
        fullWidth
        maxWidth="md"
        onClose={event => setOpenCommentDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Comment WorkOrderCommentsData={WorkOrderCommentsData} readonly={false} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setOpenCommentDialog(false)}
            aria-label="comment"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

Summary.propTypes = {
  className: PropTypes.string,
  ReceiptNo: PropTypes.string,
  tasks: PropTypes.object
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(Summary);
